(() => {
  if (window.__auraReplayControllerReady) return;
  window.__auraReplayControllerReady = true;

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest?.('[data-aura-replay]');
      if (!trigger) return;

      // A touchscreen-generated click can report no mouse button or `-1`.
      // Reject only an explicitly non-primary mouse button so touch, pen,
      // keyboard, and normal left-click activation all follow the same path.
      if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const replayUrl = new URL(trigger.href || '/', window.location.origin);
      replayUrl.searchParams.set('aura_replay', '1');
      replayUrl.searchParams.set('aura_replay_run', Date.now().toString());

      window.location.assign(replayUrl.toString());
    },
    true
  );
})();
